export * from './user-avatar.component';
